import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public title: BehaviorSubject<string> = new BehaviorSubject('');
  public conditionModalTitle: BehaviorSubject<string> = new BehaviorSubject('');
  public severity: BehaviorSubject<Object> = new BehaviorSubject(
    JSON.parse(localStorage.getItem('severity'))
  );
  public endCorrection: BehaviorSubject<Object> = new BehaviorSubject(
    JSON.parse(localStorage.getItem('end_correction'))
  );
  public overall: BehaviorSubject<Object> = new BehaviorSubject(
    JSON.parse(localStorage.getItem('overall'))
  );
  public vehicle_id: BehaviorSubject<string> = new BehaviorSubject(
    localStorage.getItem('vehicleId')
  );
  public vinInformation: BehaviorSubject<Object> = new BehaviorSubject(
    JSON.parse(localStorage.getItem('vinInfo'))
  );
  public options: BehaviorSubject<Object> = new BehaviorSubject(
    JSON.parse(localStorage.getItem('options'))
  );
  public flags: BehaviorSubject<Object> = new BehaviorSubject(
    JSON.parse(localStorage.getItem('flags'))
  );
  public gallerySubmitted: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public queryParamCheck: BehaviorSubject<boolean> = new BehaviorSubject(
    JSON.parse(localStorage.getItem('isQueryParams'))
  );

  constructor() {}

  ngOnInit(): void {}

  set setTile(title: string) {
    this.title.next(title);
  }

  set setSeverity(severity: Object) {
    localStorage.setItem('severity', JSON.stringify(severity));
    this.severity.next(severity);
  }

  set setEndCorrectionData(data: Object) {
    localStorage.setItem('end_correction', JSON.stringify(data));
    this.endCorrection.next(data);
  }

  set setOverall(data: Object) {
    localStorage.setItem('overall', JSON.stringify(data));
    this.overall.next(data);
  }

  set setConditionModalTitle(title: string) {
    this.conditionModalTitle.next(title);
  }

  set setGallerySubmission(isSubmitted: boolean) {
    this.gallerySubmitted.next(isSubmitted);
  }

  set setVehicleId(vehicle_id: string) {
    localStorage.setItem('vehicleId', vehicle_id);
    this.vehicle_id.next(vehicle_id);
  }

  set setVinInfo(info: Object) {
    try {
      console.log('setVinInfo before');
      localStorage.setItem('vinInfo', JSON.stringify(info));
      this.vinInformation.next(info);
      console.log('setVinInfo after');
    } catch (err) {
      console.log(err, 'setVinInfo error');
    }
  }

  public get vinData(): Observable<any> {
    return this.vinInformation.pipe(map((item) => item));
  }

  set setOptions(options: Object) {
    localStorage.setItem('options', JSON.stringify(options));
    this.options.next(options);
  }

  set setFlags(flags: Object) {
    localStorage.setItem('flags', JSON.stringify(flags));
    this.flags.next(flags);
  }

  set setQueryParamCheck(isQueryParams: boolean) {
    localStorage.setItem('isQueryParams', JSON.stringify(isQueryParams));
    this.queryParamCheck.next(isQueryParams);
  }

  get getQueryParamCheck() {
    return this.queryParamCheck.value;
  }

  get getTitle() {
    return this.title.value;
  }

  get getVehicleId() {
    return this.vehicle_id.value;
  }

  dataURItoBlob(dataURI: any) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }
}
